import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { jarvisRMSDashboardOnboardedActions } from "stores/jarvisRMS/jarvisRMSDashboard/jarvisRMSDashboardonboardedActions";

const mapStateToProps = (state) => {
  return {
    marketCapStats: state.jarvisRMS.RMSDashboardOnboarded.marketCapStats,
    sectorDiversificationStats:
      state.jarvisRMS.RMSDashboardOnboarded.sectorDiversificationStats,
    rmsTabData: state.jarvisRMS.RMSDashboardOnboarded.rmsTabData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMarketCapDataAction:
        jarvisRMSDashboardOnboardedActions.getMarketCapAction,
      getSectorDiversificationAction:
        jarvisRMSDashboardOnboardedActions.getSectorDiversificationAction,

      getRMSAction: jarvisRMSDashboardOnboardedActions.getRMSAction,
    },
    dispatch
  );

const RMSPortfolioAnalyseDataStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default RMSPortfolioAnalyseDataStore;
